/**
 * Minimal service-worker registration helper.
 *
 * The actual SW logic lives in `public/service-worker.js` (copied from
 * `packages/bc-ui/service-worker.js` during M6.1). This module just
 * registers it on `window.load` in production builds.
 *
 * The `?v=...` query parameter on the SW URL is the cache-busting
 * version key. We embed `process.env.REACT_APP_SW_VERSION` if set
 * (the M7 CI/CD workflow injects the commit SHA), otherwise fall back
 * to a build-time timestamp baked into the JS bundle. Either way, a
 * fresh deploy invalidates the previous SW's caches.
 *
 * In development we explicitly UNREGISTER any previously-installed SW
 * so HMR + craco's dev server can serve fresh assets without the SW
 * intercepting them.
 */

const SW_VERSION =
  process.env.REACT_APP_SW_VERSION || `dev-${Date.now()}`;

export function register() {
  if (process.env.NODE_ENV !== "production") {
    unregister();
    return;
  }
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js?v=${encodeURIComponent(SW_VERSION)}`;
    navigator.serviceWorker
      .register(swUrl)
      .catch((err) => {
        // Don't toast — SW failure is non-fatal. The app still works
        // online; users just don't get the offline fallback.
        // eslint-disable-next-line no-console
        console.warn("SW registration failed:", err);
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {
      // Best-effort — ignore.
    });
}
